import React from 'react';
import { Box, Icon, Popover, SpaceBetween } from '@amzn/awsui-components-core';
import styles from './styles.module.scss';

interface ValueWithLabelProps {
  label: string;
  description?: string;
  children: React.ReactNode;
}

export const ValueWithLabel: React.FC<ValueWithLabelProps> = ({ label, description, children }) => (
  <SpaceBetween size="xxxs">
    <Box variant="awsui-key-label">
      <span className={styles.labelWithIcon}>
        <span>{label}</span>
        {description && (
          <Popover content={description} dismissButton={false} size="small" triggerType="custom">
            <Icon name="status-info" size="small" variant="subtle" />
          </Popover>
        )}
      </span>
    </Box>
    <div>{children}</div>
  </SpaceBetween>
);
